import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';
import { Email } from "@mui/icons-material";

const defaultToolbarStyles = {
    iconButton: {
    },
};
var iniPurchase;



class TicketsEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.ticketsId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            TicketsId: data[0].ticketsId,
            Name: data[0].name,
            Description: data[0].description,
            Purchase_Id: data[0].purchase_Id,
            Status: data[0].status,
            Solution: data[0].solution,
            ExternalLink: data[0].externalLink,
            Modifier: data[0].modifier,
            StartTime: data[0].startTime,
            EndTime: data[0].endTime,
            purchase: (Object.keys(props.lookupLists.purchase).map((d) => ({ value: d, label: props.lookupLists.purchase[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniPurchase = this.state.purchase.find(({ value }) => value === (this.state.Purchase_Id || '').toString());
        
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            TicketsId: this.state.data[0].ticketsId,
            Name: this.state.data[0].name,
            Description: this.state.data[0].description,
            Purchase_Id: this.state.data[0].purchase_Id,
            Status: this.state.data[0].status,
            Solution: this.state.data[0].solution,
            ExternalLink: this.state.data[0].externalLink,
            Modifier: this.state.data[0].modifier,
            StartTime: this.state.data[0].startTime,
            EndTime: this.state.data[0].endTime
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            TicketsId: this.state.TicketsId,
            Name: this.state.Name,
            Description: this.state.Description,
            Purchase_Id: this.state.Purchase_Id,
            Status: this.state.Status,
            Solution: this.state.Solution,
            ExternalLink: this.state.ExternalLink,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, purchase } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Tickets.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Tickets.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Tickets.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniPurchase}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Purchase_Id')}
                                options={purchase}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Tickets.Columns[3]} />}
                            />
                        </Box>
                        
                        <TextField
                            margin="dense"
                            label={dictionary.Tickets.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.Status}
                            onChange={this.handleChange('Status')}
                        />

                        <TextField
                            margin="dense"
                            label={dictionary.Tickets.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.Solution}
                            onChange={this.handleChange('Solution')}
                        />

                        <TextField
                            margin="dense"
                            label={dictionary.Tickets.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.ExternalLink}
                            onChange={this.handleChange('ExternalLink')}
                        />
                        
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />

            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "TicketsEdit" })(TicketsEdit);
